export const HOTELS_DECORATIVE_IMAGE_URL =
  '/assets/wedding-websites/hotels/wedding_website_hotels_graphic.svg';
